/**
 * This code was AUTOGENERATED using the codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
} from '@solana/kit';

export type Lockup = {
  unixTimestamp: bigint;
  epoch: bigint;
  custodian: Address;
};

export type LockupArgs = {
  unixTimestamp: number | bigint;
  epoch: number | bigint;
  custodian: Address;
};

export function getLockupEncoder(): Encoder<LockupArgs> {
  return getStructEncoder([
    ['unixTimestamp', getI64Encoder()],
    ['epoch', getU64Encoder()],
    ['custodian', getAddressEncoder()],
  ]);
}

export function getLockupDecoder(): Decoder<Lockup> {
  return getStructDecoder([
    ['unixTimestamp', getI64Decoder()],
    ['epoch', getU64Decoder()],
    ['custodian', getAddressDecoder()],
  ]);
}

export function getLockupCodec(): Codec<LockupArgs, Lockup> {
  return combineCodec(getLockupEncoder(), getLockupDecoder());
}
